import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { ProductoInterface } from "../../interfaces/productoInterfaces/Producto.interface";

export async function UpdateProductoAction(
  productoId: string,
  formData: FormData
): Promise<ApiResponse<ProductoInterface>> {
  const { data } = await apiClient.put<ProductoInterface>(
    `gpProductos/${productoId}`,
    formData
  );
  return {
    status: 200,
    data,
    message: "Producto actualizada correctamente",
  };
}
